//Viene chiamata da Admin
//verifica se è già stata fatta l'autenticazione...
// sei autenticato? ->InsertForm
// non sei autenticato ->Login

import React from "react";
import useStyleChoice from "../../styles/adminStyles/useStyleChoice";

import { useAuth0 } from "@auth0/auth0-react";
import InsertForm from "./InsertForm";
import Login from "./Login";
import Direction from "../Direction";

function Choices() {
  const classes = useStyleChoice();
  //const { loginWithRedirect, isAuthenticated } = useAuth0();
  const { isAuthenticated } = useAuth0();

  return (
    <div className={classes.involucro}>
      {!isAuthenticated && <Login />}
      {isAuthenticated && <InsertForm />}
      {/* {isAuthenticated && <Direction /> } */}
    </div>
  );
}

export default Choices;
